import { SINGLE_VALUE_IN_ARRAY } from 'Core/constants/defaultValues'
import { DEFAULT_MANDATORY_ERROR } from 'Core/constants/messages'

export const generateDefaultMandatoryError = (entityName: string): string =>
	`${entityName} cannot be saved. ${DEFAULT_MANDATORY_ERROR}`

export const generateInvalidValuesError = (fields: string[]): string =>
	`Invalid value${
		fields.length > SINGLE_VALUE_IN_ARRAY ? 's' : ''
	}, please enter a correct ${fields?.join(', ')}`
